import React, { useMemo, useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getPlaylistForTeam } from '../config/playlist-links';

// Minimal sticky Spotify controller inspired by persistent mini-players
// Seen on sites like Azuki [https://www.azuki.com/].
// This floats at bottom-right on desktop and bottom on mobile.

const StickySpotify = () => {
  const [open, setOpen] = useState(false);
  const { selectedTeam } = useTheme();
  const src = useMemo(() => {
    const fallback = 'https://open.spotify.com/embed/playlist/37i9dQZF1DX4eRPd9frC1m';
    if (!selectedTeam?.name) return fallback;
    return getPlaylistForTeam(selectedTeam.name) || fallback;
  }, [selectedTeam?.name]);

  return (
    <div
      className="fixed z-40"
      style={{
        right: '1rem',
        bottom: '1rem',
      }}
    >
      <div
        className="bg-white/90 backdrop-blur-md shadow-lg border border-gray-200 rounded-full flex items-center"
        style={{ overflow: 'hidden' }}
      >
        {open ? (
          <div className="flex items-center">
            <iframe
              title="Sticky Spotify"
              src={src}
              width="300"
              height="80"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              style={{ border: 0 }}
            />
            <button
              onClick={() => setOpen(false)}
              className="px-3 py-2 text-sm text-gray-600 hover:text-gray-900"
              aria-label="Collapse player"
            >
              ✕
            </button>
          </div>
        ) : (
          <button
            onClick={() => setOpen(true)}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900"
            aria-label="Open Spotify player"
          >
            ▶ Music
          </button>
        )}
      </div>
    </div>
  );
};

export default StickySpotify;


